
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconAskMark',
  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 20
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 20
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
})
